import { ApiKeysPage } from "@/features/developer/api-keys";

export default function DeveloperApiKeysPage() {
  return <ApiKeysPage />;
}
